import { useEffect, useRef } from 'react'

export function Dropdown({ isOpen, onClose, children, className = '' }) {
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest('.dropdown-toggle')
      ) {
        onClose()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [onClose])

  if (!isOpen) return null

  return (
    <div ref={dropdownRef} className={`absolute z-40 right-0 mt-2 rounded-xl border border-gray-200 bg-white shadow-lg ${className}`}>
      {children}
    </div>
  )
}
